import { BaseService } from './base'
import { APIPath } from 'utility/constant'

/** NULL / missing DB value is treated as true (backward compat). */
const toEffective = (res) => {
    if (typeof res?.EffectiveValue === 'boolean') return res.EffectiveValue
    if (typeof res?.Value === 'boolean') return res.Value
    return true
}

class ShowPhotoGpsServiceClass {
    getCompany() {
        return BaseService.get(APIPath.companyShowPhotoGps)
    }

    setCompany(value) {
        return BaseService.put(APIPath.companyShowPhotoGps, { Value: !!value })
    }

    getUser() {
        return BaseService.get(APIPath.userShowPhotoGps)
    }

    setUser(value) {
        return BaseService.put(APIPath.userShowPhotoGps, { Value: !!value })
    }

    /** Resolve EffectiveValue (Value ?? true) from a GET response. */
    effective(res) {
        return toEffective(res)
    }
}

const ShowPhotoGpsService = new ShowPhotoGpsServiceClass()
Object.freeze(ShowPhotoGpsService)
export { ShowPhotoGpsService }
